var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCameraIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 22,
    viewBox: "0 0 30 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6321 0C18.21 0 20.708 2.41076 20.708 5.86559V15.8004C20.708 19.2553 18.21 21.666 14.6321 21.666H6.0759C2.49802 21.666 0 19.2553 0 15.8004V5.86559C0 2.41076 2.49802 0 6.0759 0H14.6321ZM26.528 3.43621C27.1765 3.1136 27.9373 3.14733 28.5563 3.52859C29.1753 3.90839 29.5446 4.56827 29.5446 5.28973V16.3772C29.5446 17.1001 29.1753 17.7585 28.5563 18.1383C28.218 18.3451 27.8398 18.4506 27.4587 18.4506C27.1411 18.4506 26.8235 18.3773 26.5266 18.2292L24.3388 17.15C23.5292 16.7482 23.027 15.9416 23.027 15.0457V6.61976C23.027 5.72232 23.5292 4.9158 24.3388 4.51694L26.528 3.43621Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraIcon1);
export default __webpack_public_path__ + "static/media/cameraIcon1.f22e40e91c56b23363f4f764bbbae9dd.svg";
export { ForwardRef as ReactComponent };